// extracted by mini-css-extract-plugin
export var Copyright = "styles-module--Copyright--Yewao";
export var Logo = "styles-module--Logo--1reoA";
export var Logo_Image = "styles-module--Logo_Image--2kBGL";